import { RumInitConfiguration } from "@datadog/browser-rum";

export class DatadogResolver {
  static resolveConfig(
    environment: string,
    version: string | undefined
  ): RumInitConfiguration {
    const sbxEnvironments = ["dev", "local"];
    const useSbx =
      sbxEnvironments.includes(environment) ||
      (process.env["NODE_ENV"] === "development" &&
        process.env["REACT_APP_BUILD_NUMBER"] === "local");
    const env = useSbx ? "dev" : environment;

    const applicationId = useSbx ? "3d5ffca7-8f93-431e-a0a0-cbaf49e272be" : "58dd6b39-fe59-4d48-9718-b94da8ea0d86";
    const clientToken = useSbx ? "pub987a21701ac704f1acaad0c3bf7d5b72" : "pube373c97c0343187d1da4fec8f03278d2";

    return {
      applicationId: applicationId,
      clientToken: clientToken,
      site: "datadoghq.com",
      service: "thirdpartyfnol",
      env: env,
      version: version,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
    };
  }
}
